<app-grid>
  <app-cell mobile="0:12" tablet="2:10">
    <div class="quotes-container">
      <div class="overlay"></div>
      <swiper [config]="swiperConfig" (swiper)="onSwiper($event)" (slideChange)="slideChange($event)">
        @for (quote of quotes; track quote) {
          <ng-template
            swiperSlide
            >
            @if (quote.name) {
              <h5
                class="title subheading"
                >
                {{ 'testimonials.testimonials' | translate }}
              </h5>
            }
            <div class="quote">
              <h1 class="quote--text serif">
                "{{ quote.text }}"
              </h1>
              @if (quote.name || quote.title) {
                <div
                  class="line"
                ></div>
              }
              <div class="quote--name">
                {{ quote.name }}
              </div>
              <div class="quote--title">
                {{ quote.title }}
              </div>
            </div>
          </ng-template>
        }
      </swiper>

      @if (quotes) {
        @if (quotes!.length > 1 || (quotes!.length === 1 && quotes[0].photo!)) {
          <div class="quotes-navigation">
            @for (person of quotes; track person; let i = $index) {
              <div
                class="navigation--person"
                [class.active]="swiperIndex === i && quotes!.length > 1"
                [class.no-pointer]="quotes!.length === 1"
                [class.no-photo]="! person.photo"
                (click)="goToSlide(i)"
                >
                @if (person.photo) {
                  <img
                    [src]="person.photo.url"
                    [alt]="person.name"
                    loading="lazy"
                    />
                }
              </div>
            }
          </div>
        }
      }
    </div>
  </app-cell>
</app-grid>
